import {SocialAdsetsCustomParam} from 'common/src/modules/social/social.types';
import {AdSetsPageState} from './adsetsTab.types';
import {SocialCampaignStatuses} from '../../campaigns.types';

const CUSTOM_PARAMS_COUNT = 5;

const generateCustomParamsArray = (paramsNumber: number): SocialAdsetsCustomParam[] => {
  return Array.from({length: paramsNumber}, (_, index) => ({
    id: `Custom${index + 1}`,
    title: `Custom ${index + 1}`,
    colName: `Custom Param ${index + 1}`,
    value: '',
  }));
};

const CUSTOM_PARAMS_TEMPLATE_ARRAY = generateCustomParamsArray(CUSTOM_PARAMS_COUNT);

const CAMPAIGN_STATUS_INITIAL_VALUES: SocialCampaignStatuses = {
  adGroupsStatuses: {},
  campaignsStatuses: {},
};

const ADSETS_TAB_INITIAL_STATE: AdSetsPageState = {
  integratedAccountOptions: [],
  integratedAccountOptionsLoading: false,
  _loading: false,
  adGroups: [],
  modalAction: null,
  isActionsMenuOpen: false,
  selectedAdGroupIds: [],
  activeAdGroup: null,
  addingIntegration: false,
  importCustomParamsResult: null,
  accountCampaigns: [],
  accountCampaignsLoading: false,
  connectedAccountId: null,
  connectedCampaignIds: [],
  removingIntegration: false,
  customParams: CUSTOM_PARAMS_TEMPLATE_ARRAY,
  campaignStatuses: CAMPAIGN_STATUS_INITIAL_VALUES,
};

const ADSETS_TAB_SLICE_NAME = 'ADSETS_TAB';

export {ADSETS_TAB_INITIAL_STATE, ADSETS_TAB_SLICE_NAME, CUSTOM_PARAMS_TEMPLATE_ARRAY};
